<div class="container" #separatore>
  <div [ngClass]="styleSeparatore || 'medium'">
    <div class="titolo">
      {{ titoloSeparatore }}
    </div>
    <div class="separatore-linea">
      <hr class="solid" />
    </div>
  </div>
</div>
